import { Spin } from "antd";
import { useLocation } from "react-router-dom";
import { useTextsContext, useCompare } from "../../providers";
import { getPreguntaIdFromPath } from "../../config/preguntaPaths";
import { getModuleConfig } from "../../config/modulePageConfig";
import P1ChartSection from "../../features/charts/p1/P1ChartSection";
import P2ChartSection from "../../features/charts/p2/P2ChartSection";
import P3ChartSection from "../../features/charts/p3/P3ChartSection";
import P4ChartSection from "../../features/charts/p4/P4ChartSection";
import P5ChartSection from "../../features/charts/p5/P5ChartSection";
import styles from "./Home.module.css";

interface ModuleReportContentProps {
  title: string;
  navLabel: string;
}

function renderChartSection(preguntaId: string | null): React.ReactNode {
  switch (preguntaId) {
    case "p1":
      return <P1ChartSection />;
    case "p2":
      return <P2ChartSection />;
    case "p3":
      return <P3ChartSection />;
    case "p4":
      return <P4ChartSection />;
    case "p5":
      return <P5ChartSection />;
    default:
      return (
        <div className={styles.pendingCard}>
          <p className={styles.pendingMessage}>Pendent de definició funcional</p>
        </div>
      );
  }
}

const ModuleReportContent = ({ title, navLabel }: ModuleReportContentProps) => {
  const { pathname } = useLocation();
  const preguntaId = getPreguntaIdFromPath(pathname);
  const { texts, loading, error } = useTextsContext();
  const { chartConfig } = getModuleConfig(pathname);
  const { isComparing } = useCompare();
  const preguntaTexts = preguntaId && texts ? texts[preguntaId] : null;
  const text = preguntaTexts?.text_resum ?? null;

  return (
    <>
      <div className={isComparing ? styles.compareHeader : styles.homeHeader}>
        {isComparing
          ? <span className={styles.compareTitle}>{navLabel} / Visualització ampliada</span>
          : <>
              <div className={styles.updateInfo}>Fonts actualitzades el 01/02/2026</div>
              <h1 className={styles.mainTitle}>{title}</h1>
            </>
        }
      </div>
      <div className={`${styles.homeContainer} ${isComparing ? styles.homeContainerCompare : ""}`}>
        <div className={`${styles.aiSummary} ${isComparing ? styles.hiddenSection : ""}`}>
          <h2 className={styles.aiSummaryTitle}>Resum IA</h2>
          <div className={styles.aiSummaryContent}>
            {loading && (
              <div className={styles.aiSummaryLoading}>
                <Spin size="small" /> Carregant resum…
              </div>
            )}
            {!loading && error && (
              <p className={styles.aiSummaryError}>{error}</p>
            )}
            {!loading && !error && text && (
              <div className={styles.aiSummaryText}>{text}</div>
            )}
            {!loading && !error && !text && (
              <p className={styles.aiSummaryEmpty}>Pendent de generació</p>
            )}
          </div>
        </div>

        {chartConfig
          ? (
            <div className={isComparing ? styles.chartExpandedWrapper : undefined}>
              {renderChartSection(preguntaId)}
            </div>
          )
          : (
            <div className={styles.pendingCard}>
              <p className={styles.pendingMessage}>Pendent de definició funcional</p>
            </div>
          )
        }
      </div>
    </>
  );
};

export default ModuleReportContent;
